<template>
  <main class="home">
    <LimitIncrease />
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import LimitIncrease from "@/apps/credit-line/components/LimitIncrease.vue";
import { setLanguage } from "@/apps/credit-line/helpers/translations.helper";

export default defineComponent({
  name: "LimitIncreaseView",
  components: {
    LimitIncrease,
  },
  beforeMount() {
    setLanguage(this);
  },
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/constants";

.green {
  color: $pj-color-green;
}
</style>
